import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useUpdateTiktokShopConfigurationStatusMutation = createMutationHook(
  CreatorIntegrationsApiClient.updateTiktokPartnerConfigurationStatus,
  {
    mutationKey: ['updateTiktokShopConfigurationStatus'],
  },
)
